/* eslint-disable react-hooks/exhaustive-deps */
import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { showToast } from 'modules/layout/layout.actions';
import React, { useState } from 'react';

import { POST_CANDIDATE_SERVICES_FAILURE, UPDATE_CANDIDATE_SERVICES_FAILURE } from 'modules/authorizations/store/types/canidateTripTypes';
import {
  getCandidateServices,
  postCandidateServices,
  updateCandidateServices
} from 'modules/authorizations/store/actions/canidateTrip.actions';
import EditableCard from 'modules/common/editableCard.component';
import { useEffect } from 'react';
import { FormatPersonName } from '../global/DestServices/formData/formDataConstants';
import { GET_SERVICE_STATUS_DATES_FAILURE } from 'modules/authorizations/store/types/authorizationTypes';
import { getServiceStatusDates } from 'modules/authorizations/store/actions/authorizations.actions';

const CandidateServicesOverviewEditableCard = props => {
  const { candidateServices, moveTypeId, brokerAgents, isReadOnly, authId, setStatuses, setCurrentStatus } = props;

  const candidateInternService = candidateServices.candidateInternService;
  const candidateInternAreaTour = candidateServices.candidateInternAreaTour;

  const [isLoading, setIsLoading] = useState(false);
  const [areaTourInitiated, setAreaTourInitiated] = useState(
    candidateInternAreaTour && candidateInternAreaTour.areaTourId > 0 ? true : false
  );
  const [areaTourAgent, setAreaTourAgent] = useState(
    candidateInternAreaTour && candidateInternAreaTour.areaTourAgentId
      ? brokerAgents.find(agent => agent.agentId === candidateInternAreaTour.areaTourAgentId)
      : null
  );

  const enrichAdvanceSearch = contacts =>
    (contacts ?? []).map(c => {
      const fullName = FormatPersonName(c);
      return {
        ...c,
        fullName
      };
    });

  const enrichedBrokers = enrichAdvanceSearch(brokerAgents);

  const brokerAgentSearchInfo = {
    searchingColumns: [
      { name: 'agentId', title: 'Broker Id' },
      { name: 'vendorId', title: 'Vendor Id' },
      { name: 'fullName', title: 'Full Name' },
      { name: 'phone', title: 'Contact Phone' },
      { name: 'email', title: 'Contact Email' }
    ],
    searchingColumnExtensions: [
      { columnName: 'agentId', width: 150 },
      { columnName: 'vendorId', width: 150 },
      { columnName: 'fullName', width: 200 },
      { columnName: 'phone', width: 175 },
      { columnName: 'email', width: 175 }
    ],
    searchingRows: enrichedBrokers,
    idKey: 'agentId',
    nameKey: 'fullName'
  };

  const candidateTabs = [{ header: 'Candidate Services Overview', order: 1, iconPath: ['fas', 'fa-id-card'] }];

  const internTabs = [{ header: 'Intern Services Overview', order: 1, iconPath: ['fas', 'fa-id-card'] }];

  const candidateSummaries = [
    {
      header: 'Init Call Date',
      accessorKey: 'serviceInitiationDate',
      type: 'date',
      required: false,
      value: candidateInternService ? candidateInternService.serviceInitiationDate : null,
      tab: 1
    },
    {
      header: 'Interview Start Date',
      accessorKey: 'startDate',
      type: 'date',
      required: false,
      value: candidateInternService ? candidateInternService.startDate : null,
      tab: 1
    },
    {
      header: 'Interview End Date',
      accessorKey: 'endDate',
      type: 'date',
      required: false,
      value: candidateInternService ? candidateInternService.endDate : null,
      tab: 1
    },
    {
      header: 'Service Completed Date',
      accessorKey: 'serviceCompletionDate',
      type: 'date',
      required: false,
      value: candidateInternService ? candidateInternService.serviceCompletionDate : null,
      tab: 1,
      disabled: false
    },
    {
      header: 'Service Cancelled Date',
      accessorKey: 'canceledDate',
      type: 'date',
      required: false,
      value: candidateInternService ? candidateInternService.canceledDate : null,
      tab: 1,
      disabled: true
    },
    {
      header: 'Area Tour',
      accessorKey: 'areaTour',
      type: 'checkbox',
      required: false,
      value: areaTourInitiated ? areaTourInitiated : false,
      tab: 1
    },
    {
      header: 'Area Tour Initiation Date',
      accessorKey: 'areaTourInitiationDate',
      type: 'date',
      required: false,
      value: candidateInternAreaTour ? candidateInternAreaTour.areaTourInitiationDate : null,
      tab: 1,
      dependentOn: 'areaTour'
    },
    {
      header: 'Area Tour Canceled Date',
      accessorKey: 'areaTourCanceledDate',
      type: 'date',
      required: false,
      value: candidateInternAreaTour ? candidateInternAreaTour.areaTourCanceledDate : null,
      tab: 1,
      dependentOn: 'areaTour'
    },
    {
      header: 'Area Tour Completed Date',
      accessorKey: 'areaTourCompletedDate',
      type: 'date',
      required: false,
      value: candidateInternAreaTour ? candidateInternAreaTour.areaTourCompletedDate : null,
      tab: 1,
      dependentOn: 'areaTour'
    },
    {
      header: 'Area Tour Agent',
      accessorKey: 'areaTourAgentId',
      nameKey: 'agentName',
      nameValue: areaTourAgent ? FormatPersonName(areaTourAgent) : '',
      type: 'advanced-search',
      searchInfo: brokerAgentSearchInfo,
      required: true,
      value: candidateInternAreaTour ? candidateInternAreaTour.areaTourAgentId : '',
      tab: 1,
      dependentOn: 'areaTour'
    }
  ];

  const internSummaries = [
    {
      header: 'Init Call Date',
      accessorKey: 'serviceInitiationDate',
      type: 'date',
      required: false,
      value: candidateInternService ? candidateInternService.serviceInitiationDate : null,
      tab: 1
    },
    {
      header: 'Internship Start Date',
      accessorKey: 'startDate',
      type: 'date',
      required: false,
      value: candidateInternService ? candidateInternService.startDate : null,
      tab: 1
    },
    {
      header: 'Internship End Date',
      accessorKey: 'endDate',
      type: 'date',
      required: false,
      value: candidateInternService ? candidateInternService.endDate : null,
      tab: 1
    },
    {
      header: 'Estimated Start Date',
      accessorKey: 'estimatedStartDate',
      type: 'date',
      required: false,
      value: candidateInternService ? candidateInternService.estimatedStartDate : null,
      tab: 1
    },
    {
      header: 'Service Completed Date',
      accessorKey: 'serviceCompletionDate',
      type: 'date',
      required: false,
      value: candidateInternService ? candidateInternService.serviceCompletionDate : null,
      tab: 1,
      disabled: false
    },
    {
      header: 'Service Cancelled Date',
      accessorKey: 'serviceCancelledDate',
      type: 'date',
      required: false,
      value: candidateInternService ? candidateInternService.serviceCancelledDate : null,
      tab: 1,
      disabled: true
    },
    {
      header: 'Area Tour',
      accessorKey: 'areaTour',
      type: 'checkbox',
      required: false,
      value: areaTourInitiated ? areaTourInitiated : false,
      tab: 1
    },
    {
      header: 'Area Tour Initiation Date',
      accessorKey: 'areaTourInitiationDate',
      type: 'date',
      required: false,
      value: candidateInternAreaTour ? candidateInternAreaTour.areaTourInitiationDate : null,
      tab: 1,
      dependentOn: 'areaTour'
    },
    {
      header: 'Area Tour Canceled Date',
      accessorKey: 'areaTourCanceledDate',
      type: 'date',
      required: false,
      value: candidateInternAreaTour ? candidateInternAreaTour.areaTourCanceledDate : null,
      tab: 1,
      dependentOn: 'areaTour'
    },
    {
      header: 'Area Tour Completed Date',
      accessorKey: 'areaTourCompletedDate',
      type: 'date',
      required: false,
      value: candidateInternAreaTour ? candidateInternAreaTour.areaTourCompletedDate : null,
      tab: 1,
      dependentOn: 'areaTour'
    },
    {
      header: 'Area Tour Agent',
      accessorKey: 'areaTourAgentId',
      nameKey: 'agentName',
      nameValue: areaTourAgent ? areaTourAgent.firstName + ' ' + areaTourAgent.lastName : '',
      type: 'advanced-search',
      searchInfo: brokerAgentSearchInfo,
      required: true,
      value: candidateInternAreaTour ? candidateInternAreaTour.areaTourAgentId : '',
      tab: 1,
      dependentOn: 'areaTour'
    }
  ];

  useEffect(() => {
    if (candidateInternService && candidateInternService.areaTourId) {
      setAreaTourInitiated(true);
    } else {
      setAreaTourInitiated(false);
    }

    if (candidateInternAreaTour && candidateInternAreaTour.areaTourAgentId) {
      setAreaTourAgent(brokerAgents?.find(agent => agent.agentId === candidateInternAreaTour.areaTourAgentId));
    } else {
      setAreaTourAgent(null);
    }
  }, [candidateInternService, candidateInternAreaTour, brokerAgents]);

  const safeDateValue = date => {
    if (!date || date === '') return null;

    if (typeof date === 'string') {
      const trimmed = date.trim();

      if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
        return trimmed;
      }

      const parsed = new Date(trimmed);
      if (!isNaN(parsed.getTime())) {
        return parsed.toISOString().slice(0, 10);
      }

      return null;
    }

    if (date instanceof Date && !isNaN(date.getTime())) {
      return date.toISOString().slice(0, 10);
    }

    return null;
  };

  const updateFields = async (tab, values) => {
    setIsLoading(true);

    let newVals = { ...candidateServices };
    
    newVals.candidateInternService.serviceInitiationDate = safeDateValue(values.serviceInitiationDate);
    newVals.candidateInternService.serviceCompletionDate = safeDateValue(
      values.serviceCompletionDate ?? values.serviceCompletedDate
    );
    newVals.candidateInternService.startDate = safeDateValue(values.startDate);
    newVals.candidateInternService.endDate = safeDateValue(values.endDate);
    newVals.candidateInternService.estimatedStartDate = safeDateValue(values.estimatedStartDate);
    if (values.areaTour) {
      if (!newVals.candidateInternAreaTour) newVals.candidateInternAreaTour = {};

      newVals.candidateInternAreaTour.areaTourInitiationDate =
        safeDateValue(values.areaTourInitiationDate) ?? new Date().toISOString().slice(0, 10);
      newVals.candidateInternAreaTour.areaTourCanceledDate = safeDateValue(values.areaTourCanceledDate);
      newVals.candidateInternAreaTour.areaTourCompletedDate = safeDateValue(values.areaTourCompletedDate);
      newVals.candidateInternAreaTour.areaTourAgentId = values.areaTourAgentId === '' ? null : values.areaTourAgentId;
    } else {
      newVals.candidateInternService.areaTourId = null;
      newVals.candidateInternAreaTour = null;
    }

    if (candidateServices.candidateInternService.candidateInternServiceId > 0) {
      const resp = await props.updateCandidateServices(newVals);
      if (resp.type === UPDATE_CANDIDATE_SERVICES_FAILURE) {
        props.showToast('Failed to update the employee candidate services info, please try again.', {
          severity: TOAST_MESSAGE_SEVERITY_ERROR
        });
        setIsLoading(false);
        return false;
      }
    } else {
      const resp = await props.postCandidateServices(newVals);
      if (resp.type === POST_CANDIDATE_SERVICES_FAILURE) {
        props.showToast('Failed to update employee candidate services info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
        setIsLoading(false);
        return false;
      }
    }
    const candResp = await props.getCandidateServices(candidateInternService.authorizationFileId);
    setCurrentStatus(candResp?.response?.candidateInternService?.statusId);
    const getStatusDatesResp = await props.getServiceStatusDates(authId);
    if (getStatusDatesResp.type === GET_SERVICE_STATUS_DATES_FAILURE) {
      setIsLoading(false);
      return false;
    } else {
      setStatuses(getStatusDatesResp.response.filter(s => s.serviceType === 'Candidate/Intern'));
      setIsLoading(false);
      return true;
    }
  };

  return (
    <EditableCard
      tabs={moveTypeId && moveTypeId === '4dc01913-217d-44bd-8e4e-82c8b82f6de4' ? internTabs : candidateTabs}
      summaries={moveTypeId && moveTypeId === '4dc01913-217d-44bd-8e4e-82c8b82f6de4' ? internSummaries : candidateSummaries}
      numColumns={4}
      updateFields={updateFields}
      isLoading={isLoading}
      smallerModal={true}
      hideEdit={isReadOnly}
    />
  );
};

export default compose(
  connect(null, {
    updateCandidateServices,
    postCandidateServices,
    getCandidateServices,
    getServiceStatusDates,
    showToast
  })
)(CandidateServicesOverviewEditableCard);
